var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17414_317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50118 1.43445C7.11256 1.19918 5.8418 0.53483 5.08604 0.113742C4.42568 -0.2534 4.22538 0.53483 4.16244 1.0748C4.0995 1.61627 4.0995 2.31659 4.79183 2.31659H7.33334C8.02567 2.31659 8.02567 1.75614 7.50118 1.43445Z",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.77793e-06 4.17625V5.7632C-0.000995246 6.35063 0.195813 6.64684 0.980047 6.64684H6.77489V3.37903H0.965061C0.171336 3.37853 3.77793e-06 3.64027 3.77793e-06 4.17625Z",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.662367 14.0711C0.66986 15.2944 1.38366 15.9922 2.90817 15.9922H6.73693V7.85614H0.662367C0.662367 7.85614 0.653376 12.8483 0.662367 14.0711Z",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9844 4.24363C15.9844 3.70766 15.7511 3.37848 14.9579 3.37848H9.24547V6.64629H15.0028C15.7871 6.64629 15.9849 6.37505 15.9844 5.78763C15.9819 5.25265 15.9829 4.77911 15.9844 4.24363Z",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9783 1.06327C11.9154 0.523295 11.7151 -0.264935 11.0542 0.102206C10.2974 0.523295 9.02769 1.18765 8.63907 1.42441C8.11358 1.7446 8.11358 2.30505 8.8074 2.30505H11.3484C12.0412 2.30505 12.0412 1.60424 11.9783 1.06327Z",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.24547 7.85614V15.9922H12.9573C14.4809 15.9922 15.1672 15.2264 15.1757 14.0041C15.1847 12.7808 15.1732 7.85614 15.1732 7.85614H9.24547Z",
    fill: "#F7931A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17414_317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15.985,
    fill: "white",
    transform: "translate(0 0.00750732)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.2f52caa299b0fdc72c994947c4412f63.svg";
export { ForwardRef as ReactComponent };